export enum BooleanOpertators{
  AND,
  OR
}